"use client"

import { SOURCE_FILTER_ROW, sourceFilterPill } from "@/components/source-filter-pill"

export type HentaieraCategory = "" | "manga" | "doujinshi" | "western" | "image-set" | "artist-cg" | "game-cg"

interface HentaieraCategoryTabsProps {
  value: HentaieraCategory
  onChange: (value: HentaieraCategory) => void
}

// Mirrors hentaiera.com's own top-level category nav. These were previously
// surfaced as six fake "gallery" posts in the results grid — each one a hardcoded
// pink SVG placeholder reading "Category" — so the section names were invisible
// and picking one meant clicking what looked like a broken thumbnail.
const OPTIONS: { value: HentaieraCategory; label: string }[] = [
  { value: "", label: "All" },
  { value: "manga", label: "Manga" },
  { value: "doujinshi", label: "Doujinshi" },
  { value: "western", label: "Western" },
  { value: "image-set", label: "Image Set" },
  { value: "artist-cg", label: "Artist CG" },
  { value: "game-cg", label: "Game CG" },
]


export function HentaieraCategoryTabs({ value, onChange }: HentaieraCategoryTabsProps) {
  return (
    <div className={SOURCE_FILTER_ROW}>
      {OPTIONS.map((opt) => {
        const isActive = value === opt.value
        return (
          <button
            key={opt.value || "all"}
            onClick={() => onChange(opt.value)}
            className={sourceFilterPill(isActive)}
          >
            {opt.label}
          </button>
        )
      })}
    </div>
  )
}
